<template>
  <div class="case">
    <div class="case-title">
      <div>案例介绍</div>
    </div>
    <div class="case-content">
      <div class="case-item">
        <div class="item-til">
          <div></div>
          旅游行业
        </div>
        <p class="item-ind">
          我们通过对景点、旅行社、游客等与旅游相关的信息的整合分析、汇集游客反馈，为景区、政府管理部门和旅游企业等提供基于大数据的事前研判，辅助相关机构做好相应的人力、运力、食品、安全等事项的决策与规划，科学管理、精准营销，确保游客的安全，提升旅游服务和品质
        </p>
      </div>
      <div class="case-item">
        <div class="item-til">
          <div></div>
          教育行业
        </div>
        <p class="item-ind">
          大数据技术背景下，教育行业整体向智慧化、人性化与科学化有了更多的提升变化。我们通过整合学校、学生、教师等多位教育资源数据，并对其进行挖掘分析，可以更好地优化教育资源，实现多种资源的融合、共享与利用，在学生管理、学校治理以及教育规划等多方便提升，实现智慧教育与智慧管理
        </p>
      </div>
      <div class="case-item">
        <div class="item-til">
          <div></div>
          医疗行业
        </div>
        <p class="item-ind">
          我们通过整合医疗、药品、食品检验、食品生产、气象和社交网络等相关数据，构建医疗大数据公共平台，辅助相关企业充分掌握医疗行业最新发展动态，掌握最新的技术进展，帮助相关企业进行药品的安全研发与科学管理等
        </p>
      </div>
      <div class="case-item">
        <div class="item-til">
          <div></div>
          食品行业
        </div>
        <p class="item-ind">
          我们通过检测食品领域的热点事件、网红爆款流向、先进技术工艺扥个，为相关企业提供基于大数据的事前研判，辅助相关企业做好宣传推广、危机应对等决策与规划，提高服务质量
        </p>
      </div>
      <div class="case-item">
        <div class="item-til">
          <div></div>
          农林牧渔业
        </div>
        <p class="item-ind">
          大数据正在驱动整个教育行业产业向智慧化、人性化与科学化多方面的大提升。通过整合学校、学生、教师等等多位教育资源数据，并做挖掘分析，可以更好地提高并优化教育资源，实现多种资源的融合、共享与利用，在学生管理、学校治理以及教育规划等多方面提升，实现智慧教育与智慧管理。
        </p>
      </div>
      <div class="case-item">
        <div class="item-til">
          <div></div>
          家居行业
        </div>
        <p class="item-ind">
          家居行业，服务流程复杂、信息不透明，极易诱发负面舆情，如产品质检不合格、产品运输物流不到位、产品售后服务问题等；同时，掌握最新的政策走向，把握政策监管趋势，对企业发展至关重要。通过大数据对家居行业进行检测，有利于企业做好品牌口碑检测，便于企业发现服务中存在的问题，并能提出相应的改进方案。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../../styles/global.less';
.case-title {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 536px;
  background: url(~@/assets/image/back_case.png) center no-repeat;
  background-size: 100% 100%;
  div {
    margin: 48px 0;
    font-size: 48px;
    font-weight: 600;
    color: #ffffff;
  }
}
.case-content {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  width: 80%;
  margin: 64px auto;
  .case-item {
    width: 38%;
    min-height: 260px;
    padding: 24px;
    margin: 24px 0;
    background: #ffffff;
    border-radius: 10px;
    box-shadow: 0px 0px 16px 0px #cfd8eb;
    .item-til {
      position: relative;
      font-size: 24px;
      font-weight: 600;
      color: #333333;
      div {
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 20px;
        opacity: 0.3;
        background: #0377ff;
        border-radius: 10px;
      }
    }
    .item-ind {
      margin: 24px 0;
      font-size: 18px;
      font-weight: 400;
      color: #656565;
      line-height: 32px;
      text-indent: 2em;
    }
  }
}
</style>
